import loadable from '@nordvpn/teams.core/lib/tools/loadable';
import { RouteGenerator } from 'routing/RouteGenerator';
import { PermissionsEnum } from 'types/permissions/enums';
import { COUPONS_CREATE_PATH, COUPONS_EDIT_PATH, COUPONS_LIST_PATH } from './constants';
var Coupons = loadable(function () {
    return import(/* webpackPrefetch: true */ 'utils/lazy/entry/Pages/CouponsList');
});
var CreateCoupon = loadable(function () {
    return import(/* webpackPrefetch: true */ 'utils/lazy/entry/Pages/CreateCouponPage');
});
var EditCoupon = loadable(function () {
    return import(/* webpackPrefetch: true */ 'utils/lazy/entry/Pages/EditCouponPage');
});
export var CouponsRouting = function CouponsRouting() {
    return RouteGenerator({
        list: {
            path: COUPONS_LIST_PATH,
            component: Coupons,
            exact: true,
            permission: PermissionsEnum.ViewCoupon
        },
        create: {
            path: COUPONS_CREATE_PATH,
            component: CreateCoupon,
            exact: true,
            permission: PermissionsEnum.CreateCoupon
        },
        edit: {
            path: COUPONS_EDIT_PATH,
            component: EditCoupon,
            exact: true,
            permission: PermissionsEnum.ModifyCoupon
        }
    });
};
